import { decodeCompanyRequisites } from 'models/Company/CompanyRequisites';
import { ServerApi } from 'modules/api/server-api';

export const fetchCompanyRequisites = (api: ServerApi) => async () => {
  const response = await api.get('/v3/company/documents/legal-entity');
  return decodeCompanyRequisites(response.data);
};
